module.exports = __webpack_public_path__ + "media/theme/step--3-bfd33b56.png";